<template>
  <div v-loading="loading">
    <el-row class="clearfix">
      <el-col :span="5" style="font-weight: 600;font-size: 14px;">银行卡管理</el-col>
      <el-col :span="5" :offset="14" class="btn-sty">
        <button @click="add('add')">添加银行卡</button>
      </el-col>
    </el-row>
    <el-row v-if="listflag" class="clearfix account-1" :gutter="40">
      <el-col :span="12" class="accountlist" v-for="bank in bankList" :key="bank.Id">
        <div class="account-sty clearfix">
          <el-col :span="24" class="name">
            卡号：{{ bank.BankCardNum }}<span><template v-if="bank.IsDefault">默认</template></span>
          </el-col>
          <el-col :span="24" class="phone">
            {{ bank.AccountBankName }}
          </el-col>
          <el-col :span="24" class="time">
            开户地：{{ bank.ProvinceName }} {{ bank.CityName }}
          </el-col>
          <el-col :span="24" class="btns">
            <div>
              <button @click="deleteBank(bank.Id)">删除</button>
              <button v-if="!bank.IsDefault" @click="setDefault(bank.Id)">设为默认</button>
            </div>
          </el-col>
        </div>
      </el-col>
      <div v-if="bankList.length == 0" class="noaccount">
        暂时没有银行卡，如需要可以点击右上角添加
      </div>

    </el-row>
    <div v-show="!listflag" class="form-add">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px" label-position="left">
        <el-row>
          <el-col :span="24">
            <el-form-item label="开户人" prop="AccountHolderName">
              <el-input v-model="form.AccountHolderName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="银行预留手机号" prop="PhoneNumer">
              <el-input v-model="form.PhoneNumer" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="身份证号" prop="ContactCardNumber">
              <el-input v-model="form.ContactCardNumber" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="银行卡号" prop="BankCardNum">
              <el-input v-model="form.BankCardNum" autocomplete="off" @change="onAccountChange($event)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="开户行" prop="Bank">
              <el-select style="width: 100%;" v-model="form.BankCode" placeholder="请选择">
                <el-option
                  v-for="item in BanksArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-form-item label="开户地址" prop="ProvinceId">
              <el-select v-model="form.ProvinceId" placeholder="请选择" @change="loadCity($event)">
                <el-option
                  v-for="item in Provinces"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="1">
            <el-select v-model="form.CityId" placeholder="请选择" @change="loadBankBranch($event)">
              <el-option
                v-for="item in Citys"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>

          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="开户支行" prop="AccountBankCode">
              <el-select style="width: 100%;" v-model="form.AccountBankCode" placeholder="请选择"
                         @change="accountbank($event)">
                <el-option
                  v-for="item in AccountBankArr"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!---->
        <!--<auto-form style="width:100%" :url="url.pay" ref="form" :rules="rules1" :form="form1" label-width="150px" :formTemplate="formTemplate"  @beforeSave="beforeSave" @afterSaved="afterSaved" @onSavedError="onSavedError" @saved="saved">-->
        <!--<slot></slot>-->
        <!--</auto-form>-->
        <el-col :span="24">
          <el-form-item label="设为默认">
            <el-switch
              v-model="form.IsDefault"
              active-color="#FF6A00"
              inactive-color="#dddddd">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-form>
      <div class="form-btn">
        <button @click="submitData">添加</button>
        <button @click="backlist">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
import AutoForm from '@/components/AutoForm'

export default {
  data() {
    let validateBankcard2 = (rule, value, callback) => {
      if (!this.form.Account) {
        callback();
        // }
        // else if (!this.bankIsOk) {
        //   callback(new Error('您输入的银行卡号暂不支持！'));
      } else {
        validateBankcard(rule, value, callback);
      }
    };
    return {
      form: {
        Id: '',
        CustomId: '',//客户Id
        CustomName: '',//客户名称
        ProvinceName: '',//省
        CityName: '',//市
        BankCode: '',//开户行名称
        AccountBankName: '',//开户支行名称
        BankCardNum: '',//银行卡号
        PhoneNumer: '',//银行预留手机号
        AccountHolderName: '',//开户人
        ContactCardNumber: '',//身份证号
        IsDefault: false,//是否默认
        CreateBy: '',//创建人
        CreateTime: '',//创建时间
        UpdateTime: '',//更新时间

        Account: '',
        Bank: '',
        ProvinceId: '',
        CityId: '',
        VCode: '',
        AccountBankCode: '',
      },
      Provinces: [],
      Citys: [],
      BanksArr: [],
      AccountBankArr: [],
      listflag: true,
      loading: false,
      bankList: [],
      url: {
        list: SZH.assets.api + '/Custom/GetCustomBankCardList',
        save: SZH.assets.api + '/Custom/SaveCustomBankCard',
        delete: SZH.assets.api + '/Custom/DeleteCustomBankCard',
        SetCustomDefaultCard: SZH.assets.api + '/Custom/SetCustomDefaultCard',
        get: SZH.assets.api + '/Custom/GetCustomChild',
        bank: SZH.assets.api + "/Market/GetSelectBaseBank",
        province: SZH.assets.api + "/Market/GetSelectProvince",
        city: SZH.assets.api + "/Market/GetSelectCity",
        bankBranch: SZH.assets.api + "/Market/GetSelectBankInfo",
        bankSearch: SZH.assets.api + "/Market/GetBankMapping",
        sendPhoneVCodeOld: SZH.assets.api + "/Authen/SendVerifyCode2",
        pay: ''
      },
      rules: {
        AccountHolderName: [{
          required: true,
          message: '请输入开户人姓名',
          trigger: 'blur'
        },],
        PhoneNumer: [{
          required: true,
          message: '请输入银行预留手机号',
          trigger: 'blur'
        }, {
          validator: validatePhone,
          trigger: 'blur'
        }],
        ContactCardNumber: [{
          required: true,
          message: '请输入身份证号',
          trigger: 'blur'
        }, {
          validator: validateIdCard,
          trigger: 'blur'
        }],
        BankCardNum: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'blur'
          },
          {
            validator: validateBankcard2,
            trigger: 'blur'
          }
        ],
        BankCode: [{required: true, message: '请选择开户行', trigger: 'change'}],
        ProvinceId: [{required: true, message: '请选择开票所在省份', trigger: 'change'}],
        City: [{required: true, message: '请选择开票所在城市', trigger: 'change'}],
        AccountBankCode: [{required: true, message: '请选择开户银行支行', trigger: 'change'}],
      },
      formTemplate: [
        {
          col: 24, label: '短信验证码', prop: 'Vcode', type: 'v-code', click: (c) => {
            this.sendVcode(c);
          }
        },
      ],
      form1: {
        Vcode: '',
        LoginPortId: '1', // 仓库id
      },
      rules1: {
        Vcode: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 6,
            message: '短信验证码长度应为6个字符',
            trigger: 'blur'
          }
        ],
      },
    }
  },
  methods: {
    getList() {
      let self = this;
      self.loading = true;
      self.$http.post(self.url.list, {}).then(result => {
        if (result.state == 1 && result.data != null) {
          self.loading = false;
          self.bankList = result.data;
        } else {
          self.loading = false;
          self.bankList = [];

        }
      }, () => {
      });
    },

    add(val, id) {
      let self = this;
      self.listflag = false;
      self.$nextTick(()=>{
        this.$refs['form'].resetFields();
      })
    },
    submitData() {
      let self = this;
      self.$refs['form'].validate(valid => {
        if (valid) {
          self.loading = true;
          self.$http.post(self.url.save, {keyValue: self.form}).then(result => {
            if (result.state == true) {
              self.loading = false;
              self.listflag = true;
              self.$message({
                type: 'success',
                message: result.message
              });
              self.getList();
            } else {
              self.loading = false;
              self.$message.error(result.message);
            }
          }, () => {
          });
        } else {
          return false;
        }
      });


    },
    deleteBank(id) {
      this.$confirm('确认要删除此银行卡吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$http.post(this.url.delete, {keyValue: id}).then(result => {
          if (result.state == true) {
            this.loading = false;
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getList();
          } else {
            this.loading = false;
            this.$message({
              type: 'error',
              message: result.message
            });
          }
        }, () => {
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    setDefault(id) {
      this.$confirm('确认要将此银行卡设置为默认银行卡吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$http.post(this.url.SetCustomDefaultCard, {keyValue: id}).then(result => {
          if (result.state == true) {
            this.loading = false;
            this.$message({
              type: 'success',
              message: '设置成功!'
            });
            this.getList();
          } else {
            this.loading = false;
            this.$message({
              type: 'error',
              message: result.message
            });
          }
        }, () => {
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消设置'
        });
      });
    },
    backlist() {
      this.listflag = true;
    },

    sendVcode(collback) {
      var self = this;
      self.$http.post(self.url.sendPhoneVCodeOld, {
        Template: 1
      }).then(result => {
        if (result.State == 1) {
          self.$message.success("验证码发送成功！");
          collback();
        } else {
          self.$message.error(result.Message);
        }
      }, () => {
      });
    },
    beforeSave() {
      this.isBtn = true;
    },
    afterSaved() {
      this.isBtn = false;
    },
    onSavedError() {
      this.isBtn = false;
    },
    saved() {

    },

    //银行省市相关信息
    onAccountChange(v) {
      var self = this;
      if (v != null && v.length >= 6) {
        var s = v.substring(0, 6);
        self.$http.post(self.url.bankSearch, {
          Data: s
        }).then(result => {
          if (result.state == true && result.data != null) {
            self.form.BankCode = result.data.BankId
          } else {
          }
        }, () => {
        });
      }
    },
    loadProvince() {
      var self = this;
      self.$http.post(self.url.province, {}).then(result => {
        if (result.state == true && result.data.length > 0) {
          self.Provinces = result.data;
        }
      }, () => {
      });
    },
    loadCity(id) {
      var self = this;
      self.form.CityId = ''
      self.form.CityName = ''
      let obj = {};
      obj = self.Provinces.find((item) => {
        return item.id === id;//筛选出匹配数据
      });
      self.form.ProvinceName = obj.label;
      self.$http.post(self.url.city, {
        keyValue: self.form.ProvinceId,
        Keyword: ''
      }).then(result => {
        if (result.state == true && result.data.length > 0) {
          self.Citys = result.data;
        }
      }, () => {
      });
    },

    loadBankBranch(id) {
      var self = this;
      let obj = {};
      obj = self.Citys.find((item) => {
        return item.id === id;//筛选出匹配数据
      });
      self.form.CityName = obj.label;
      let NewCityId = self.form.CityId.slice(0, 4)
      if (self.form.BankCode) {
        self.$http.post(self.url.bankBranch, {
          keyValue: {
            BankId: self.form.BankCode,
            CityId: NewCityId,
          }
        }).then(result => {
          self.AccountBankArr = result.data;
        }, () => {
        });
      } else {
        self.$message.error("请先选择开户行！")
      }

    },
    accountbank(id) {
      var self = this;
      let obj = {};
      obj = self.AccountBankArr.find((item) => {
        return item.id === id;//筛选出匹配数据
      });
      self.form.AccountBankName = obj.label;
    },
    loadBanks() {
      var self = this;
      self.$http.post(self.url.bank, {}).then(result => {
        if (result.state == 1 && result.data.length > 0) {
          self.BanksArr = result.data;
        }
      }, () => {
      });
    },
  },
  computed: {},
  components: {
    AutoForm
  },
  mounted() {
    this.getList();
    this.loadBanks();
    this.loadProvince();
  }
}
</script>

<style scoped>
.btn-sty button {
  float: right;
  color: white;
  background: #FF6A00;
  padding: 5px 20px;
  box-shadow: none;
  border: 0px;
  cursor: pointer;

}

.account-sty {
  background: #CC9966;
  padding: 20px 10px 10px 30px;
  border-radius: 8px;
  clear: both;
}

.account-sty .name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.account-sty .name span {
  font-size: 14px;
  float: right;
  color: grey;
}

.account-sty .phone {
  color: grey;
  margin-bottom: 10px;

}

.account-sty .time {
  color: grey;
  margin-bottom: 10px;
}

.btns > div {
  float: right;
}

.btns button {
  border-radius: 20px;
  padding: 5px 15px;
  color: #FF6A00;
  background: white;
  box-shadow: none;
  border: 0px;
  transition: all 0.6s;
  cursor: pointer;
}

.btns button:hover {
  color: white;
  background: #FF6A00;
  transition: all 0.6s;
}

.account-1 {
  padding: 0px 60px;
  margin-top: 50px;
}

.accountlist {
  margin-top: 20px;
}

.form-add {
  padding: 50px 250px;
}

.form-btn {
  text-align: center;
}

.form-btn button {
  padding: 7px 25px;
  color: #FF6A00;
  background: white;
  box-shadow: none;
  border: 1px solid #FF6A00;
  cursor: pointer;
}

.form-btn button:first-child {
  padding: 7px 25px;
  margin-right: 40px;
  color: white;
  background: #FF6A00;
  box-shadow: none;
  border: 0px;
  transition: all 0.6s;
  cursor: pointer;
}

.noaccount {
  width: 100%;
  height: 500px;
  background: #dddddd;
  color: #f5f5f5;
  font-size: 20px;
  line-height: 500px;
  text-align: center;
}

.btn-yz {
  background: #FF6A00;
  border: 0px;
  box-shadow: none;
  padding: 10px 20px;
  color: white;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Me/BankCard/BankCard.vue